import { FC } from 'react';

type ShippingIconProps = {
  className?: string;
};

const ShippingIcon: FC<ShippingIconProps> = ({ className = 'stroke-gray-500' }) => {
  return (
    <span className="relative" data-testid="shipping-icon">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_22410_48958)">
          <path
            d="M10.6667 2H0.666748V10.6667H10.6667V2Z"
            className={className}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.6667 5.33334H13.3334L15.3334 7.33334V10.6667H10.6667V5.33334Z"
            className={className}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.66667 14C4.58714 14 5.33333 13.2538 5.33333 12.3333C5.33333 11.4128 4.58714 10.6667 3.66667 10.6667C2.74619 10.6667 2 11.4128 2 12.3333C2 13.2538 2.74619 14 3.66667 14Z"
            className={className}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.3334 14C13.2539 14 14.0001 13.2538 14.0001 12.3333C14.0001 11.4128 13.2539 10.6667 12.3334 10.6667C11.4129 10.6667 10.6667 11.4128 10.6667 12.3333C10.6667 13.2538 11.4129 14 12.3334 14Z"
            className={className}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_22410_48958">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
};

export default ShippingIcon;
